
var support = {};

var tests = {
  ipad: function () {
    return navigator.userAgent.match(/.*(iPad).*/) ? true : false;
  },
  iphone: function () {
    return navigator.userAgent.match(/.*(iPhone).*/) ? true : false;
  },
  touch: function () {
    return 'ontouchstart' in window || /*|| (navigator.maxTouchPoints > 0)*/navigator.msMaxTouchPoints > 0;
  },
  //IE10 Pointers
  msPointer: function () {
    return !!window.navigator.msPointerEnabled;
  },
  //IE11 Pointers
  pointer: function () {
    return !!window.navigator.pointerEnabled;
  },
  pointerdown: function () {
    return this.touch() ? 'touchstart' : this.pointer() ? 'pointerdown' : this.msPointer() ? 'MSPointerDown' : 'mousedown';
  },
  pointerup: function () {
    return this.touch() ? 'touchend' : this.pointer() ? 'pointerup' : this.msPointer() ? 'MSPointerUp' : 'mouseup';
  },
  pointermove: function () {
    return this.touch() ? 'touchmove' : this.pointer() ? 'pointermove' : this.msPointer() ? 'MSPointerMove' : 'mousemove';
  },
  pointerenter: function () {
    return this.touch() ? 'touchstart' : this.pointer() ? 'pointerenter' : this.msPointer() ? 'MSPointerEnter' : 'mouseenter';
  },
  pointerleave: function () {
    return this.touch() ? 'touchend' : this.pointer() ? 'pointerleave' : this.msPointer() ? 'MSPointerLeave' : 'mouseleave';
  },
  pointerover: function () {
    return this.touch() ? 'touchstart' : this.pointer() ? 'pointerover' : this.msPointer() ? 'MSPointerOver' : 'mouseover';
  },
  pointerout: function () {
    return this.touch() ? 'touchend' : this.pointer() ? 'pointerout' : this.msPointer() ? 'MSPointerOut' : 'mouseout';
  },
  //use multi prefix for older version of light compatibility
  multipointerdown: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mousedown', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerdown'] : this.msPointer() ? ['MSPointerDown'] : ['mousedown', 'pointerdown'];
  },
  multipointerup: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseup', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerup'] : this.msPointer() ? ['MSPointerUp'] : ['mouseup', 'pointerup'];
  },
  multipointermove: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mousemove', 'touchmove'] : ['touchmove'] : this.pointer() ? ['pointermove'] : this.msPointer() ? ['MSPointerMove'] : ['mousemove', 'pointermove'];
  },
  multipointerenter: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseenter', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerenter'] : this.msPointer() ? ['MSPointerEnter'] : ['mouseenter'];
  },
  multipointerleave: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseleave', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerleave'] : this.msPointer() ? ['MSPointerLeave'] : ['mouseleave'];
  },
  multipointerover: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseover', 'touchstart'] : ['touchstart'] : this.pointer() ? ['pointerover'] : this.msPointer() ? ['MSPointerOver'] : ['mouseover'];
  },
  multipointerout: function () {
    return this.touch() ? 'onmousedown' in window && !this.ipad() && !this.iphone() ? ['mouseout', 'touchend'] : ['touchend'] : this.pointer() ? ['pointerout'] : this.msPointer() ? ['MSPointerOut'] : ['mouseout'];
  },
};

var featureName;
for (var feature in tests) {
  if (tests.hasOwnProperty(feature)) {
    featureName = feature;
    support[featureName] = tests[feature]();
  }
}

export default support
